import { render, staticRenderFns } from "./ProjectArchiveButton.vue?vue&type=template&id=b98f6684&scoped=true&"
import script from "./ProjectArchiveButton.vue?vue&type=script&lang=js&"
export * from "./ProjectArchiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98f6684",
  null
  
)

export default component.exports